import template from './report.html';
import controller from './report.controller';


import './report-widget.styl';

let reportComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default reportComponent;



// WEBPACK FOOTER //
// ./client/app/components/report/report.component.js